/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerGetSegmentAdOverlayByDateQueryResponse, PntSegmentsControllerGetSegmentAdOverlayByDatePathParams, PntSegmentsControllerGetSegmentAdOverlayByDateQueryParams } from "../models/PntSegmentsControllerGetSegmentAdOverlayByDate";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntSegmentsControllerGetSegmentAdOverlayByDate } from "../axios/pntSegmentsControllerGetSegmentAdOverlayByDate";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntSegmentsControllerGetSegmentAdOverlayByDateQueryKey = (slug: PntSegmentsControllerGetSegmentAdOverlayByDatePathParams["slug"], params: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/adoverlay', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntSegmentsControllerGetSegmentAdOverlayByDateQueryKey = ReturnType<typeof pntSegmentsControllerGetSegmentAdOverlayByDateQueryKey>

export function pntSegmentsControllerGetSegmentAdOverlayByDateQueryOptions(slug: PntSegmentsControllerGetSegmentAdOverlayByDatePathParams["slug"], params: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntSegmentsControllerGetSegmentAdOverlayByDateQueryKey(slug, params)
        return queryOptions<PntSegmentsControllerGetSegmentAdOverlayByDateQueryResponse, ResponseErrorConfig<Error>, PntSegmentsControllerGetSegmentAdOverlayByDateQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntSegmentsControllerGetSegmentAdOverlayByDate(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve the ad overlays for a time range
 * {@link /pnt/v2/segments/:slug/adoverlay}
 */
export function usePntSegmentsControllerGetSegmentAdOverlayByDate<TData = PntSegmentsControllerGetSegmentAdOverlayByDateQueryResponse, TQueryData = PntSegmentsControllerGetSegmentAdOverlayByDateQueryResponse, TQueryKey extends QueryKey = PntSegmentsControllerGetSegmentAdOverlayByDateQueryKey>(slug: PntSegmentsControllerGetSegmentAdOverlayByDatePathParams["slug"], params: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntSegmentsControllerGetSegmentAdOverlayByDateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntSegmentsControllerGetSegmentAdOverlayByDateQueryKey(slug, params)
         

         const query = useQuery({
          ...pntSegmentsControllerGetSegmentAdOverlayByDateQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}